// extracted by mini-css-extract-plugin
export default {"add":"_2Ni7n pull-item-button"};